export default "__VITE_ASSET__bPPTfU5k__"